import { Address, Base, CodeDesc, IMyInfo, Value } from './myinfo.type';
import { DeepPartial } from '@core/util';
import { PositionCode } from './position-code.type';
import { CategoryCode } from './category-code.type';

export type CorppassProfile = {
  entity: IEntity;
  person: IMyInfo;
};

export type IEntity = DeepPartial<Entity>;

type Entity = {
  'basic-profile': Base & {
    uen: Value<string>;
    'entity-name': Value<string>;
    'entity-type': CodeDesc<'LC' | 'FC'>;
    'entity-status': Value<string>;
    'primary-activity': CodeDesc;
    'primary-user-described-activity': Value<string>;
    'secondary-activity': CodeDesc;
    'secondary-user-described-activity': Value<string>;
    'registration-date': Value<string>;
    'company-type': CodeDesc;
    // 'company-type': CodeDesc<CompanyType>;
    ownership: CodeDesc;
    'country-of-incorporation': CodeDesc;
    'business-constitution': CodeDesc<'S' | 'P'>;
    'business-expiry-date': Value<string>;
  };
  addresses: Base & {
    'addresses-list': Array<
      Address & {
        standard: CodeDesc;
      }
    >;
  };
  appointments: Base & {
    'appointments-list': AppointmentsList[];
  };
  capitals: Base & {
    'capitals-list': Capital[];
  };
  shareholders: Base & {
    'shareholders-list': ShareholdersList[];
  };
  'previous-uens': Base & {
    'previous-uens-list': Array<{
      'previous-uen': Value<string>;
    }>;
  };
  'previous-names': Base & {
    'previous-names-list': Array<{
      'history-name': Value<string>;
      'history-name-effective-date': Value<string>;
    }>;
  };
};

type CompanyType = 'A1' | 'A3' | 'A4' | 'B1' | 'B2' | 'B3' | 'B4' | 'F1';

type Capital = {
  'capital-type': CodeDesc;
  currency: CodeDesc;
  'issued-capital-amount': Value<number>;
  'paid-up-capital-amount': Value<number>;
  'share-allotted-amount': Value<number>;
};

type AppointmentsList = {
  'person-reference': PersonReference;
  position: CodeDesc<PositionCode>;
  'appointment-date': Value<string>;
  'corppass-email': Value<string>;
  category: CodeDesc<'' | CategoryCode>;
  'corppass-mobileno': Value<string>;
};

type ShareholdersList = {
  allocation: Value<number>;
  'corppass-email': Value<string>;
  'share-type': CodeDesc;
  currency: CodeDesc;
  category: CodeDesc;
  'entity-reference'?: EntityReference;
  'corppass-mobileno': Value<string>;
  'person-reference'?: PersonReference;
};

type EntityReference = {
  'entity-name': Value<string>;
  'entity-type': CodeDesc<'LC' | 'FC'>;
  uen: Value<string>;
};

type PersonReference = {
  nationality: CodeDesc;
  idno: Value<string>;
  'person-name': Value<string>;
};
